import React from 'react'

export default function Utilities() {
	return (
		<div>
			Cover Uploader
		</div>
	)
}
